import {ExtensionBase} from "FormBuilder/Core/FormBuilder.options";
import {StoreBase, StoreDataType} from "shared/core/Store/StoreBase";
import {ConditionGroupOptions, ConditionOptionsBase} from "FormBuilder/Fields/Core/ConditionOptions";

export class ImageConditionOptions extends ExtensionBase{
    ClientOptions:ImageConditionClientOptions;

    protected LoadDefaultValues() {
        this.Id='ImageCondition';
        debugger;
        this.ClientOptions=new ImageConditionClientOptions().Merge();

    }

}

export class ImageItemOptions extends StoreBase{
    public Id:string;
    public URL:string;

    protected LoadDefaultValues() {
        this.Id='';
        this.URL='';

    }

}


export class ImageCondition extends ConditionOptionsBase{
    @StoreDataType(ImageItemOptions)
    public Images:ImageItemOptions[];

    public LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Images=[];
    }
}

export class ImageConditionClientOptions extends StoreBase{
    @StoreDataType(ImageCondition)
    public Conditions:ImageCondition[];
    protected LoadDefaultValues() {
        this.Conditions=[];
    }

}
